import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import style from "../../pages/Home/Home.module.css";
import { getHomeSections } from "../../Api/commonApis";
import { getBlogSections } from './../../Api/blogApis';
import { host_url } from "../../configiration/config";
import { Link } from 'react-router-dom';
import noImage from '../../assets/images/noImage.png';
import { filterLanguage } from './../../utilities/filterFunction';
import { basename } from './../../configiration/config';
import NoData from './../NoData/NoData';
import { Autoplay } from "swiper";

export default function BlogsSlider({ blogHeader, hideBackLayer }) {
    const [homeTitles, sethomeTitles] = useState({});
    const [loadingBlogs, setloadingBlogs] = useState(true);
    const [blogs, setBlogs] = useState([]);


    useEffect(() => {
        // get home Data
        getHomeSections().then((res) => {
            // get home titles
            let homeData = { ...homeTitles };
            homeData = res.data.data;
            sethomeTitles(homeData);
        }).catch(() => {
        })

        // get all blogs sections
        getBlogSections().then(response => {
            if (response.data.status === true) {
                let blog = [...blogs]
                blog = response.data.data.blog_sections
                setBlogs(blog)
                setloadingBlogs(false)
            }
        }).catch(error => {
            console.log(error)
            setloadingBlogs(false)
        });

        //swiper stop on hover
        let swiper_containers = document.querySelectorAll('.swiper-container');
        for (let i = 0; i < swiper_containers.length; i++) {
            swiper_containers[i].addEventListener('mouseover', function() {
                var swiper = this.swiper;
                swiper.autoplay.stop();
            });

            swiper_containers[i].addEventListener('mouseleave', function() {
                var swiper = this.swiper;
                swiper.autoplay.start();
            });
        }

        // eslint-disable-next-line
    }, []);
    return (
        <div>
            <div className={`${style.todo}`}>
                <div >
                    {blogHeader && blogHeader.locales &&
                        <>
                            <h2 className={style.sectionTitle}>{filterLanguage(blogHeader.locales)[0].title}</h2>
                            <p className={style.sectionSubTitle}>{filterLanguage(blogHeader.locales)[0].description}</p>
                        </>
                    }
                </div>
                <div className={`${style.todoCarousel} ${hideBackLayer ? style.removeLayer : ''}`} style={{ width: '100%', margin: 'auto' }}>
                    <Swiper
                        className={` d-flex align-items-center justify-content-center swiper-container`}
                        slidesPerView={3}
                        autoplay={{
                            disableOnInteraction: true,
                        }}
                        modules={[Autoplay]}
                        breakpoints={{
                            1200: {
                                slidesPerView: 3
                            },
                            1100: {
                                slidesPerView: 2
                            },
                            800: {
                                slidesPerView: 2,
                                spaceBetween: 0
                            },
                            700: {
                                slidesPerView: 1,
                                spaceBetween: 0
                            },
                            600: {
                                slidesPerView: 1,
                                spaceBetween: 0
                            },
                            500: {
                                slidesPerView: 1,
                                spaceBetween: 0
                            },
                            300: {
                                slidesPerView: 1,
                                spaceBetween: 0
                            },
                            200: {
                                slidesPerView: 1,
                                spaceBetween: 0

                            }
                        }}
                    >
                        {blogs && blogs.length > 0 && blogs.map((blog) => {
                            let selectedBlog = filterLanguage(blog.locales)
                            return (
                                <SwiperSlide key={blog.slug}>
                                    <div className={`${style.singleTodo}`}>
                                        <img src={`${host_url}/${blog.image}`} className="d-block w-100" alt="blog" onError={(e) => { e.target.src = noImage }} />
                                        <Link to={`${basename}/blogs/${blog.slug}`} className={`${style.singleTodoContent}`}>
                                            <h4>{selectedBlog.length && selectedBlog[0].name}</h4>
                                            <p>{selectedBlog.length && selectedBlog[0].description}</p>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                        }
                    </Swiper>
                    {!loadingBlogs && <NoData />}
                    {/* {loadingBlogs &&
                        <Loading width='100px' height='100px' />
                    } */}
                </div>
            </div>


        </div>
    )
}